
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import {ServiceCosmetologistsStore} from "@/store/modules/ServiceCosmetologists";
import {IServiceCosmetologists} from "@/entity/serviceCosmetologists/serviceCosmetologists.types";

@Component({
  components: {PageTitle}
})
export default class WorkerServices extends Vue {
  loading = false;
  data: any[] = [];
  searchText = '';
  searchedColumn = '';
  pagination = {
    showSizeChanger: true,
    pageSize: 10,
    total: 10,
  }

  get columns(): ITableColumn[] {
    return TablesStore.workerServicesColumns;
  }

  async created(): Promise<void> {
    await this.getServiceStaff();
    this.pagination.total = this.data.length
  }

  async getServiceStaff() {
    //await ServiceCosmetologistsStore.fetchAll({filter: {'service_id': this.service.id}});
  }

  get serviceStaff(): IServiceCosmetologists | null {
    return ServiceCosmetologistsStore.serviceCosmetologist;
  }

  handleSearch(selectedKeys: any, confirm: any, dataIndex: any): void {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = dataIndex;
  }

  handleReset(clearFilters: any): void {
    clearFilters();
    this.searchText = '';
  }
}
